import React from "react"
import Suite from "../components/Common/Suite"
import SEO from "../components/seo"
import thumbnailAgile from "../images/CleverAgile.png"

const Agile = () => {
  return (
    <>
      <SEO
        image={thumbnailAgile}
        description={
          "Live and enjoy Agile through learning and continuous improvement"
        }
        title={
          "CleverIT Group | Clever Agile | Agile Mindset | Methodology Agile"
        }
      />
      <Suite call={"agile"} />
    </>
  )
}

export default Agile
